import {css} from "styled-components";
import {interpolateRules} from "../GlobalStyles";

// Rule options
const marginDirections = ["top", "bottom", "left", "right"];
const marginGaps = [0, 3, 5, 15, 10, 20, 25, 30, 40, 50, 60]; // eslint-disable-line no-magic-numbers

const paddingDirections = marginDirections;
const paddingGaps = marginGaps;

const textAlignOptions = ["center", "left", "right"];
const textDecorationOptions = ["underline", "none"];
const fontWeightOptions = ["100", "400", "600", "900"];

const flexJustifications = ["center", "flex-start", "flex-end", "space-between", "space-around"];
const flexGaps = [0, 2, 5, 10, 15, 20, 30, 40, 50]; // eslint-disable-line no-magic-numbers
const flexDirections = ["row", "column"];
const itemsAlignment = ["center", "flex-start", "flex-end", "stretch", "baseline"];
const flexWrapValues = ["wrap", "wrap-reverse", "nowrap", "auto"];

const positions = ["absolute", "relative", "fixed", "static", "sticky"];
const opacities = [0, 1];
const displayModes = ["block", "inline", "inline-block", "none"];
const overflows = ["visible", "scroll", "hidden", "auto"];
const overflowDirections = ["x", "y"];

const InterpolationCss = css`
  // .margin-top-10, .margin-top-20...
  ${interpolateRules("margin", [marginDirections, marginGaps], "px")}
    // .padding-10, .padding-20...
  ${interpolateRules("padding", paddingGaps, "px")}
    // .padding-top-10, .padding-top-20...
  ${interpolateRules("padding", [paddingDirections, paddingGaps], "px")}
    // .flex-row, .flex-column...
  ${interpolateRules("flex-direction", flexDirections)}
    // .align-items-center...
  ${interpolateRules("align-items", itemsAlignment)}
    // .align-self-center...
  ${interpolateRules("align-self", itemsAlignment)}
    // .gap-10, .gap-20...
  ${interpolateRules("gap", flexGaps, "px")}
    // .justify-content-center ...
  ${interpolateRules("justify-content", flexJustifications)}
    // .flex-wrap-wrap...
  ${interpolateRules("flex-wrap", flexWrapValues)}
    // .text-align-center...
  ${interpolateRules("text-align", textAlignOptions)}
    // .text-decoration-underlined...
  ${interpolateRules("text-decoration", textDecorationOptions)}
    // .font-weight-100...
  ${interpolateRules("font-weight", fontWeightOptions)}
    // .position-relative...
  ${interpolateRules("position", positions)}
    // .opacity-0, .opacity-1
  ${interpolateRules("opacity", opacities)}
    // .display-block...
  ${interpolateRules("display", displayModes)}
    // .overflow-x-hidden...
  ${interpolateRules("overflow", [overflowDirections, overflows])}
`;

export default InterpolationCss;
